import {
  startOfDay,
  startOfMonth,
  startOfISOWeek,
  startOfYear,
  subDays,
  endOfDay,
} from 'date-fns';
import { DayPickerValues } from './dayPickerValues';

export function getRangeForTimePeriod(
  timePeriod: DayPickerValues,
  until: 'yesterday' | 'today' = 'today'
) {
  let startReference;
  let endDate;

  if (until === 'today') {
    startReference = startOfDay(new Date());
    endDate = new Date();
  } else {
    const yesterday = startOfDay(subDays(new Date(), 1));
    startReference = yesterday;
    endDate = endOfDay(yesterday);
  }

  const timePeriodToDateRangeMap: Record<
    DayPickerValues,
    { startDate: Date; endDate: Date }
  > = {
    '1': {
      startDate: startReference,
      endDate,
    },
    '7': {
      startDate: startOfISOWeek(startReference),
      endDate,
    },
    '30': {
      startDate: startOfMonth(startReference),
      endDate,
    },
    '365': {
      startDate: startOfYear(startReference),
      endDate,
    },
  };

  return timePeriodToDateRangeMap[timePeriod];
}
